<template>
  <div class="billing" :style="{ minHeight: 'calc(100vh - 140px)' }">
    <rCenterHeader :list="headerMenu">
      <div slot="search">
        <form>
          <Input
            size="large"
            v-model="params.keyword"
            search
            @on-search="search('')"
            @keydown.enter.native.prevent="search('')"
            @on-enter="search('')"
            :placeholder="$t('fabricLibrary.search')"
            style="width: 380px; color: #081938"
          />
          <Button
            @click="filterClick"
            class="filter"
            size="large"
            type="primary"
          >
            <span class="iconfont iconshaixuan"></span>
            {{ $t("fabricLibrary.filter") }}
          </Button>
        </form>
      </div>
    </rCenterHeader>
    <div class="list" :style="{ minHeight: 'calc(100vh - 140px)' }">
      <div v-if="total">
        <div class="bill-balance wl-flex wl-align-center">
          {{ $t("user.currentBalance") }}{{ balanceNum }}
          <!-- ,<span
            @click="toRecharge" >{{ $t("user.recharge") }} > </span
          > -->
        </div>
        <Table
          :no-data-text="$t('noDate')"
          width="1320"
          style="margin: 0 auto"
          :columns="columns"
          :data="data"
        ></Table>
      </div>
      <Spin size="large" fix v-if="spinShow"></Spin>
      <rNull
        v-if="data.length == 0 && spinShow == false"
        imgStyle="width:300px;margin:40px auto"
        titleStyle="font-size:16px;color:#999"
        :title="$t('noResult')"
      ></rNull>
      <div
        v-if="total"
        class="common-flex common-justify-center"
        style="margin-top: 20px; padding-bottom: 20px"
      >
        <Page
          ref="pages"
          :total="total"
          @on-change="changePage"
          :current="params.pageNum"
          :page-size="params.pageSize"
          show-total
          transfer
        >
          <span>{{ $t("total") }} {{ total }} {{ $t("recoprds") }}</span>
        </Page>
      </div>
    </div>
    <!-- 搜索项 -->
    <rBillingFilter
      :params="params"
      @search="search"
      @close="closeFilte"
      :filteShow="filteShow"
    ></rBillingFilter>
  </div>
</template>

<script>
import rBillingFilter from "../../components/r-billing-filter";
import rCenterHeader from "../../components/r-center-header";
import rNull from "../../components/r-null";
import { mapActions } from "vuex";
export default {
  name: "billing",
  data() {
    return {
      balanceNum: 0,
      params: {
        pageNum: 1,
        pageSize: 20,
        dealStart: "",
        dealEnd: "",
        deliveryStart: "",
        deliveryEnd: "",
        dealItem: "",
        memberId: "",
        keyword: "",
      },
      total: 0,
      spinShow: false,
      value: "",
      filteShow: false,
      // 头部面包屑
      headerMenu: [
        {
          name: this.$t("customer.crumbs.billing"),
        },
      ],
      columns: [
        {
          title: "#",
          key: "name",
          width: 60,
          render: (h, params) => {
            return h("div", {}, params.index + 1);
          },
        },
        {
          title: "Deal Item",
          key: "dealTypeName",
          width: 120,
        },
        {
          title: "Order No. | Order#",
          key: "orderNo",
          width:190,
          //   <Icon type="ios-information-circle" />
          // render: (h, params) => {
          //   return h(
          //     "div",
          //     {
          //       style: {
          //         display: "flex",
          //         alignItems: "center",
          //       },
          //     },
          //     [
          //       h("Icon", {
          //         style: {
          //           color: "#DA8100",
          //           marginRight: "4px",
          //         },
          //         attrs: {
          //           type: "ios-information-circle",
          //         },
          //         on: {
          //           click: () => {},
          //         },
          //       }),
          //       h(
          //         "div",
          //         [

          //           h("div",{
          //             // {
          //             style: {
          //               color: "#DA8100",
          //             },

          //             on: {
          //               click: () => {},
          //             },
          //           // },

          //           },params.row.orderNo),

          //           h("div",{
          //             // {
          //             style: {
          //               color: "red",
          //             },

          //             on: {
          //               click: () => {},
          //             },
          //           // },

          //           },params.row.address),
          //         ]

          //       ),
          //     ]
          //   );
          // },
        },
        {
          title: "Client",
          key: "customerName",
          width: 160,
        },
        {
          title: "Item/Fabric",
          key: "address",
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  display: "flex",
                  alignItems: "center",
                },
              },
              [
                h("img", {
                  style: {
                    display:params.row.url?'inline-block':'none',
                    width: "34px",
                    height: "34px",
                    marginRight: "14px",
                  },
                  attrs: {
                    src: params.row.url,
                  },
                  on: {
                    click: () => {},
                  },
                }),
                h(
                  "div",

                  [
                    h(
                      "div",
                      {
                        style: {
                          fontSize: "14px",
                          fontFamily: "Roboto",
                          fontWeight: 500,
                          textAlign: "left",
                          color: "#081938",
                          lineHeight: "16px",
                          marginBottom: "7px",
                        },

                        on: {
                          click: () => {},
                        },
                      },
                      params.row.category
                    ),
                    h(
                      "div",
                      {
                        style: {
                          fontSize: "10px",
                          fontFamily: "Roboto",
                          fontWeight: "400",
                          textAlign: "left",
                          color: "#081938",
                          lineHeight: "11px",
                        },

                        on: {
                          click: () => {},
                        },
                      },
                      params.row.fabric
                    ),
                  ]
                ),
              ]
            );
          },
          width: 180,
        },
        {
          title: "Qty",
          key: "amount",
          width: 80
        },
        {
          title: "Price",
          key: "price",
          width: 120,
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  display: "flex",
                  alignItems: "center",
                },
              },
              [
                h(
                  "div",
                  {
                    style: {
                      color:
                        params.row.price.split("")[0] == "+"
                          ? "#0C750E"
                          : "#F5222D",
                    },

                    on: {
                      click: () => {
                        console.log("params", params);
                      },
                    },
                  },
                  params.row.price.split(",")[0]
                ),
              ]
            );
          },
        },
        {
          title: "Date",
          key: "dealDate",
          width:180
        },
        {
          title: "Remark",
          key: "remark",
          render: (h, params) => {
            let remark= params.row.remark;
            let customRemark;
            if (remark.length > 18) { //进行截取列显示字数
              customRemark = remark.substring(0, 18) + "...";
            } else {
              customRemark = remark;
            }
            return h('Tooltip', {
              props: {
                placement: 'top'
              }
            }, [
              customRemark, // table表格显示
              h('span', {
                slot: 'content',
                style: {
                  whiteSpace: 'normal',
                  wordBreak: 'break-all'
                }
              }, remark) //Tooltip 显示
            ])
          }
        }
      ],
      data: [],
    };
  },
  components: {
    rCenterHeader,
    rBillingFilter,
    rNull,
  },
  mounted() {
    this.memberDeal();
    this.getCustBalance();

  },
  updated(){
    this.$nextTick(()=>{
      console.log(this.$refs)
    })

  },
  methods: {
    ...mapActions(["memberDealAction", "getCustBalanceAction"]),
    changePage(e) {
      this.params.pageNum = e;
      this.memberDeal();
    },
    // 获得当前余额
    getCustBalance() {
      this.getCustBalanceAction().then((res) => {
        console.log("res", res);
        this.balanceNum = res.data;
      });
    },
    // 搜索
    search(e) {
      if (e) {
        this.params = e;
      }
      this.params.pageNum = 1;
      this.closeFilte();
      this.memberDeal();
    },
    // 帐单列表
    memberDeal() {
      this.spinShow = true;
      this.memberDealAction(this.params)
        .then((res) => {
          console.log("res", res);
          this.total = res.total;
          this.data = res.data;
        })
        .finally((res) => {
          this.spinShow = false;
        });
    },
    // 显示搜搜分类
    filterClick() {
      this.filteShow = true;
      console.log('搜索')
    },
    toRecharge(){
      this.$router.push('./user')
    },
    // 关闭搜索分类
    closeFilte() {
      this.filteShow = false;
      console.log(this.params);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.billing {
  .filter {
    background: #f8f8f8;
    border: none;
    color: #081938;
    margin-left: 5px;
    width: 85px;
    font-size: 14px;
  }
  .bill-balance {
    width: 1320px;
    margin: 0 auto 22px;
    opacity: 0.8;
    font-size: 14px;
    font-family: Roboto, Roboto-Bold;
    font-weight: 700;
    text-align: left;
    color: #081938;
    line-height: 16px;
    span {
      opacity: 1;
      font-size: 14px;
      font-family: Roboto, Roboto-Bold;
      font-weight: 700;
      text-align: left;
      color: #0a4dcc;
      line-height: 16px;
      cursor: pointer;
    }
  }
  .list {
    width: 1420px;
    min-height: 100vh;
    margin: 0 auto;
    padding-top: 20px;
    background: #fff;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/billing/billing.vue